import { RootState } from 'store';
import { OkrReviewCycle } from './interfaces';

export const selectReviewCycles = (state: RootState) =>
  state.okrReviewCycles.items as OkrReviewCycle[];

export const selectReviewCycleById = (state: RootState, id: string) =>
  selectReviewCycles(state).find((item) => item.id === Number(id));
